import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormGroup, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';
import Swal from 'sweetalert2'


import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { roles } from '../../../../Shared/utils';
import { create, get } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { multiSelectStrings } from '../../../../Functions/utils';
import { useReportingContext } from '../../../../Context/Reporting/Provider';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { toastTimerValue } from '../../../../Shared/utils';
import '../../../SweetAlert.css'

export default function CreateLicense({ licenses, setLicenses, setSelectedLicense }) {
  const { t } = useTranslation();
  const [{ user }] = useAppContext();
  const [{ pickers }] = useReportingContext();

  const tmpLocations = JSON.parse(JSON.stringify(pickers.locations.all));
  const locations = tmpLocations.map(loc => { loc.label = loc.label.replace(/\u2001/g, ''); return loc; });

  const [loading, setLoading] = useState(false);
  const [newLicense, setNewLicense] = useState({
    type: '2',
    customerId: "",
    groupId: '0',
    locationId: '0',
    serverName: '',
    serial: "",
    motherboard_serial: "",
    uuid: "",
    gracePeriod: '3',
    Check_delay: '1',

    Feature_audit: true,
    Feature_diags: true,
    Feature_wipe: true,
    Feature_image_deployment: true,

    // FOR FUTUR USE ++++++++++++++
    Duration: '0',
    Nb_processes: '0',

    Platform_x64: false,
    Platform_arm64: false,
    Platform_Apple_Silicon: true,

    Feature_manual_input: false,
    Feature_tune_up: false,
    Feature_data_backup: false,
    Feature_data_backup_ex: false,
    Feature_cdp: false,
    Feature_system_backup: false,
    Feature_recovery_media: false,
    Feature_smart_repair: false,
    Feature_instant_restore: false,
    Feature_enterprise: false
    // FOR FUTUR USE ++++++++++++++
  });


  useEffect(() => {
    const groupId = pickers.groups && pickers.groups[0] && pickers.groups[0].value;
    const tmpLocations = locations.filter(loc => loc.group == groupId);
    setNewLicense({
      ...newLicense,
      groupId: pickers.groups && pickers.groups[0] && pickers.groups[0].value,
      locationId: tmpLocations && tmpLocations[0] && tmpLocations[0].value
    });
  }, [pickers]);


  const handleCreateLicense = (e, license) => {
    e.preventDefault();
    setLoading(true);

    // // Set group to NULL for SoftThinks Admins
    // user.groupId = !Number(user.groupId) ? null : user.groupId;
    // user.contactEmailActivated = user.contactEmail ? true : false;
    license.uuid = license.uuid.replace(/[^0-9a-fA-F]/g, '');

    create({ type: 'license', license }).then(res => {

      console.log("93 - res=", res);
        setLoading(false);
      if (!res || !res.success) {
        return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res, { id: license.id })), { type: 'error' });
      }

      get({ type: 'license' }).then(res => {
        setLoading(false);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('admin.licenses.errors.' + res)), { type: 'error' });
        }

        // console.log("863 -res=", res);
        const newLicenses = [];
        setLicenses(res.licenses.sort(function (a, b) {
          if (a.group && b.group && a.group.toLowerCase() < b.group.toLowerCase()) {
            return -1;
          }
          if (a.group && b.group && b.group.toLowerCase() < a.group.toLowerCase()) {
            return 1;
          }

          if (a.id && b.id && Number(a.id) < Number(b.id)) {
            return -1;
        }
          return 1;
        }));
        setSelectedLicense(null);

    });
      const newRows = licenses.concat({ ...res.license });
      setLicenses(newRows.sort((a, b) => a.id.localeCompare(b.id)));


      toast(decodeHTMLEntities(t('admin.licenses.create.success', { id: license.id })), { type: 'success' });
    });
  };

  // console.log("69 - newLicense=", newLicense);

  // console.log("69 - pickers.groups=", pickers.groups);
  // console.log("69 - locations=", locations);
  // console.log("69 - locations.filter(loc => loc.group == newLicense.groupId)", locations.filter(loc => loc.group == newLicense.groupId));

  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleCreateLicense(e, newLicense)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.licenses.create.title')}</h1>
            <div>
              <select
                value={newLicense.type}
                className="singleSelect"
                title={t('admin.licenses.columns.type')}
                onChange={e => {
                  setNewLicense({ ...newLicense, type: Number(e.target.value) });
                }}
              >
                <option value="1" disabled={true}>{t('admin.licenses.type_SDS')}</option>
                <option value="2" >{t('admin.licenses.type_MacRestorer')}</option>
                <option value="3" disabled={true}>{t('admin.licenses.type_Chromebook_solution')}</option>
                <option value="4" disabled={true}>{t('admin.licenses.type_Windows_Diagnostics')}</option>
                <option value="5" disabled={true}>{t('admin.licenses.type_SBAR')}</option>
                <option value="6" disabled={true}>{t('admin.licenses.type_OnDevice')}</option>
              </select>
            </div>
          </div>

          {newLicense.type === "2" && (

            < div >
          <div className="prompt__content">
            <div className="flexRow">
              <div>
                <p className="sidebar__label">{t('admin.licenses.columns.group')}</p>
                <select
                  value={newLicense.groupId}
                  className="singleSelect"
                      onChange={e => {
                        const tmpLoc = locations.filter(loc => loc.group == Number(e.target.value) || null);
                        const firstLoc = tmpLoc !== null ? tmpLoc[0] && tmpLoc[0].value : null ;
                        setNewLicense({ ...newLicense, groupId: Number(e.target.value) || null, locationId : firstLoc, locations: [] })} // Replace "no group" by null
                      }
                  >
                  {pickers.groups.map(group => <option key={group.value} value={group.value}>{group.label}</option>)}
                </select>
            </div>

              <div>
                <p className="sidebar__label">{t('admin.licenses.columns.location')}</p>
                <select
                  value={newLicense.locationId}
                  className="singleSelect"
                  disabled={!newLicense.groupId}
                  onChange={e => setNewLicense({ ...newLicense, locationId: Number(e.target.value) || null, locations: [] })} // Replace "no group" by null
                      >
                  {locations.filter(loc => loc.group == newLicense.groupId).map(loc => <option key={loc.value} value={loc.value}>{loc.label}</option>)}
                </select>
              </div>
                          </div>

                <br />

                <div className="prompt__content">
                  <TextField
                    required
                    name="serverName"
                    autoComplete="off"
                    variant="outlined"
                    value={newLicense.serverName}
                    label={t('admin.licenses.columns.serverName')}
                    onChange={e => setNewLicense({ ...newLicense, serverName: e.target.value })}
                  />
                </div>

                <br />

            <div className="flexRow">
                    <TextField
                      required
                name="customerId"
                autoComplete="off"
                      variant="outlined"
                value={newLicense.customerId}
                label={t('admin.licenses.columns.customerId')}
                    onChange={e => {
                      let value = parseInt(e.target.value, 10);

                      if (!isNaN(value)) {
                        if (value > 4090) value = 4090;
                        if (value < 1) value = 1;
                        setNewLicense({ ...newLicense, customerId: value })
                      }
                      else if (e.target.value === "") {
                        setNewLicense({ ...newLicense, customerId: "" })
                      }
                      else {
                        setNewLicense({ ...newLicense, customerId: newLicense.customerId })
                      }
                    }}
                    />

              <TextField
                required
                    name="Check_delay"
                    autoComplete="off"
                    type="number"
                    InputProps={{ inputProps: { min: 1, max: 30 } }}
                    variant="outlined"
                    value={newLicense.Check_delay}
                    label={t('admin.licenses.columns.Check_delay')}
                    onChange={e => setNewLicense({ ...newLicense, Check_delay: e.target.value })}
                  />

                  <TextField
                    required
                    name="gracePeriod"
                autoComplete="off"
                    type="number"
                    InputProps={{ inputProps: { min: 0, max: 7 } }}
                variant="outlined"
                value={newLicense.gracePeriod}
                label={t('admin.licenses.columns.gracePeriod')}
                onChange={e => setNewLicense({ ...newLicense, gracePeriod: e.target.value })}
              />
            </div>

            <div className="flexRow">
              <TextField
                required
                    name="hostserial"
                autoComplete="off"
                variant="outlined"
                value={newLicense.serial}
                label={t('admin.licenses.columns.serial')}
                onChange={e => setNewLicense({ ...newLicense, serial: e.target.value })}
                />

              <TextField
                required
                    name="mbserial"
                autoComplete="off"
                variant="outlined"
                value={newLicense.motherboard_serial}
                label={t('admin.licenses.columns.motherboard_serial')}
                onChange={e => setNewLicense({ ...newLicense, motherboard_serial: e.target.value })}
              />
            </div>

              <TextField
              required
                  name="uuid"
                autoComplete="off"
              variant="outlined"
              value={newLicense.uuid}
              label={t('admin.licenses.columns.uuid')}
                  inputProps={{ style: { textTransform: "uppercase" } }}
              onChange={e => setNewLicense({ ...newLicense, uuid: e.target.value })}
                  // onChange={(e) => {                    
                  //   const regex = /[0-9a-fA-F]+$/i;  // 
                  //   console.log("291 - e.target.value=", e.target.value, regex.test(e.target.value))
                  //   if (regex.test(e.target.value)) {
                  //     setNewLicense({ ...newLicense, uuid: e.target.value })
                  //   }
                  //   else {
                  //     setNewLicense({ ...newLicense, uuid: newLicense.uuid })
                  //   }
                  // }}                  
              />


                <div className="category">
                  <p className="sidebar__label">{t('admin.licenses.features') + ' (' + t('admin.licenses.type_MacRestorer') + ') '}</p>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_audit}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_audit: !newLicense.Feature_audit })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_audit_and_manual_inputs')}</label>
                  </div>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_diags}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_diags: !newLicense.Feature_diags })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_diags')}</label>
                  </div>

                  <div className="checkbox action">
                    <input
                      id="unexpectedActivity"
                      disabled={true}
                      type="checkbox"
                      defaultChecked={newLicense.Feature_wipe}
                      onChange={() =>
                        setNewLicense({ ...newLicense, Feature_wipe: !newLicense.Feature_wipe })
                      }
                    />
                    <label>{t('admin.licenses.columns.feature_wipe_and_restore')}</label>
                  </div>
                </div>
              </div>
          </div>
          )}

        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedLicense(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.create')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
